export default function formatNumber(
  value: number | string,
  locale = "de"
): string {
  const number = Number(value);
  if (isNaN(number)) return "";

  return number.toLocaleString(locale);
}
